import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Navbar, NavbarBrand, Nav, NavItem } from 'reactstrap';
import './NavBar.css';

// Set the current questionnaire name according to the page's URL (e.g. DTT/Recommendations)
function getCurrentQuestionnaireName() {
  // e.g. "/questionnaire/DTT/group/A"
  const pathName = window.location.pathname;
  var questionnaireName = pathName.split("/")[2];

  if (questionnaireName === "DTT") { questionnaireName = "Questionnaire"; }
  else if (questionnaireName === "Recommendation") { questionnaireName = "Recommendations"; }

  return questionnaireName;
}

const styles = {
  patient: {
    margin: 'auto 0 auto auto',
    color: '#0a90bb',
    cursor: 'pointer',
  },
  logout: {
    cursor: 'pointer',
  },
};

const NavBar = ({ router, history }) => (
  <div>
    <Navbar color="light" light expand="md" className="questionnaire-header">
      <NavbarBrand>Welcome</NavbarBrand>

      <h1 className="navTitle">{getCurrentQuestionnaireName()}</h1>

      <Nav className="ml-auto">
        <NavItem>
          <Link style={styles.logout} className="nav-link" to="/PatientHome">
              Patient Home
          </Link>
        </NavItem>
      </Nav>
    </Navbar>
  </div>
);

export default connect(
  state => ({
    router: state.router,
  }))(NavBar);



// WEBPACK FOOTER //
// ./src/containers/Header/NavBar.js